export enum EStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Denied = 'Denied'
}
